import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../../shared/components/base/base.component';
import {AppState} from '../../store/app.reducer';
import {Store} from '@ngrx/store';
import {TitleService} from '../../shared/services/title.service';
import {NgCacheRouteReuseService} from 'ng-cache-route-reuse';
import {UserService} from '../../shared/services/user.service';

@Component({
  selector: 'app-lending',
  templateUrl: './lending.component.html',
  styleUrls: ['./lending.component.css'],
})
export class LendingComponent extends BaseComponent implements OnInit {

  errors: string[] = [];

  constructor(
      protected store: Store<AppState>,
      private userService: UserService,
      private cacheRouteReuseService: NgCacheRouteReuseService,
      private titleService: TitleService) {
    super(store);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setTitle();

    this.cacheRouteReuseService
        .onAttach(LendingComponent)
        .subscribe((component) => {
          this.setTitle();
        });
  }


  private setTitle() {
    this.titleService.setTitle($localize`Lending`);
  }
}
